import React from 'react';
import { Heading } from 'rebass/styled-components';
import { IBuilderCtrlViewProps } from '../types';

export const HeadingCtrl: React.FC<IBuilderCtrlViewProps> = ({ properties }) => {
  return (
    <>
      <Heading>{`${(properties || {}).question || 'Title'}`}</Heading>
    </>
  );
};
